// extracted by mini-css-extract-plugin
export default {"wrapper":"PortfolioPage_wrapper__TzGC-","container":"PortfolioPage_container__d6OFi","dark":"PortfolioPage_dark__xz3jU"};